<!-- eslint-disable no-new -->
<template>
  <v-app id="dark-template">
    <div
      id="p5Canvas"
      class="bg"
    />
    <div class="fader container border">
      <v-fade-transition
        mode="out-in"
        type="animation"
      >
        <v-content>
          <v-container
            fluid
            fill-height
          >
            <v-layout
              align-center
              justify-center
            >
              <v-flex
                md10
                sm12
              >
                <v-layout wrap>
                  <v-flex
                    md4
                  >
                    <sidebar-container class="fill-height" />
                  </v-flex>
                  <v-flex
                    md8
                  >
                    <content-container class="fill-height" />
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex md12>
                    <timeline-primary />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-content>
      </v-fade-transition>
    </div>
  </v-app>
</template>

<script>
import SidebarContainer from '@/views/dark-template/sidebar/Container'
import ContentContainer from '@/views/dark-template/content/Container'
import TimelinePrimary from '@/views/dark-template/timeline/Primary'

if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  // is mobile..
} else {

}

// NOTE: Use p5 as an instance mode
const P5 = require('p5')

export default {
  name      : 'DarkTemplateContainer',
  components: {
    TimelinePrimary,
    ContentContainer,
    SidebarContainer,
  },
  mounted () {
    // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    //   /// ... mobile not working
    // } else {
    /// ---> P5 backguound
    const script = function (p5) {
      // NOTE: Set up is here
      p5.setup = (_) => {
        const canvas = p5.createCanvas(p5.windowWidth, p5.windowHeight)
        canvas.parent('p5Canvas')
        p5.strokeWeight(0.5)
        p5.stroke(255)
        p5.background(3, 202, 252)
        DrawFlower() // Calling the DrawFlower function in the setup
      }

      const DrawFlower = () => {
        for (let i = 0; i <= 600; i++) {
          const RandX = p5.random(p5.width) // Assigning the value of randomized width size to variable 'RandX'
          const RandY = p5.random(p5.height)// Assigning the value of randomized height size to variable 'RandY'
          p5.fill(255, p5.random(180), p5.random(180))
          p5.ellipse(RandX, RandY, 20, 20) // Draw ellipse with random position RandX, and RandY, and size 20
          p5.ellipse(RandX - 25, RandY - 5, 20, 20) // Draw same ellipse but adjust location
          p5.ellipse(RandX - 15, RandY + 5, 20, 20)
          p5.ellipse(RandX - 15, RandY - 20, 20, 20)
          p5.ellipse(RandX, RandY - 15, 20, 20)
          p5.fill(p5.random(80)) // Change fill
          p5.ellipse(RandX - 10, RandY - 8, 10, 10)// Draw small center ellipse
        }
      }
      p5.windowResized = (_) => {
        p5.resizeCanvas(p5.windowWidth, p5.windowHeight)
      }
    }

    new P5(script)
    /// <--- P5 backguound
    // }
  },
}
</script>

<style scoped>
body, html {
  height: 100%;
}
.fader{
  animation: fadeIn 8s;
}

@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

.bg{
    display: block;
    position: fixed;
}
</style>
